
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Heart, ShoppingCart, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CartSidebar from "@/components/CartSidebar";
import LoginModal from "@/components/LoginModal";
import { useAuth } from "@/contexts/AuthContext";

const BottomNavigation = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { isAuthenticated, checkToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleAccountClick = async () => {
    if (isAuthenticated) {
      const isValid = await checkToken();
      if (isValid) {
        navigate('/account');
      } else {
        setIsLoginModalOpen(true);
      }
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    navigate('/account');
  };

  if (!isMobile) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border">
      <div className="flex items-center justify-around py-2">
        <Button variant="ghost" size="icon" className="flex flex-col gap-1" aria-label="Favoris">
          <Heart className="h-5 w-5" />
          <span className="text-xs">Favoris</span>
        </Button>
        
        <CartSidebar isOpen={isCartOpen} onOpenChange={setIsCartOpen}>
          <Button variant="ghost" size="icon" className="flex flex-col gap-1" aria-label="Panier">
            <ShoppingCart className="h-5 w-5" />
            <span className="text-xs">Panier</span>
          </Button>
        </CartSidebar>
        
        <Button variant="ghost" size="icon" className="flex flex-col gap-1" aria-label="Compte" onClick={handleAccountClick}>
          <User className="h-5 w-5" />
          <span className="text-xs">Compte</span>
        </Button>
      </div>
      
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onOpenChange={setIsLoginModalOpen}
        onSuccess={handleLoginSuccess}
      />
    </nav>
  );
};

export default BottomNavigation;
